// 验证正则表达式
export const regexps = {
  ip: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/, // ipv4地址
  idCard: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/, // 身份证号码
  mobileNumber: /^\d{11}$/, // 手机号码
  loginPassword: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()_+=\-`{}|:”<>?[\]\\;’,./])[A-Za-z\d~!@#$%^&*()_+=\-`{}|:”<>?[\]\\;’,./]{8,20}$/, // 8-20位包含数字、字母、特殊字符
  email: /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/, // 验证邮箱
};
